import { cn } from "@heroui/theme";
import { motion } from "framer-motion";

const TotalSteps: React.FC<{
  currentStep: number;
  totalSteps: number;
  className?: string;
}> = ({ currentStep, totalSteps, className }) => {
  return (
    <div
      className={cn(
        "w-[15%] h-8 flex bg-indigo-50 rounded-full items-center justify-center space-x-2 p-1",
        className
      )}
    >
      <p className="text-indigo-600 text-xs font-medium">{currentStep + 1}</p>
      <p className="text-indigo-600 text-xs font-light">of</p>
      <p className="text-indigo-600 text-xs font-medium">{totalSteps}</p>
    </div>
  );
};

const ProgressBar = ({
  currentStep,
  totalSteps,
}: {
  currentStep: number;
  totalSteps: number;
}) => {
  const progress = ((currentStep + 1) / totalSteps) * 100;
  const displayProgress = progress === 0 ? 5 : progress;

  return (
    <div className="relative w-full mt-2 flex flex-row items-center space-x-2">
      <div className="relative w-[85%] h-8">
        <div className="w-full p-1 rounded-full bg-indigo-50 overflow-hidden h-full flex items-center">
          <motion.div
            className="px-2 flex items-center justify-end h-full rounded-full bg-indigo-600"
            initial={{ width: 0 }}
            animate={{ width: `${displayProgress}%` }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
          >
            {/* <CircleCheck className="w-4 h-4 text-white" /> */}
            {progress > 0 && (
              <span className="text-white text-xs font-normal whitespace-nowrap">
                {`${Math.round(progress)}%`}
              </span>
            )}
          </motion.div>
        </div>
      </div>
      <TotalSteps currentStep={currentStep} totalSteps={totalSteps} />
    </div>
  );
};

export { ProgressBar, TotalSteps };
